<template>
<div>

    <Row :gutter="10">
        <Col span="4">
            <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: cityFilter}"
                         :debounce="500" :skip="skipCity">
                <template slot-scope="{ result: { loading, error, data } }">
                    <div v-if="loading"> Loading...</div>
                    <div v-else-if="error"> Error Occured. {{error}}</div>
                    <div v-else>
                        <AutoComplete placeholder="Order City" v-model="city" :clearable="true" element-id="city"
                                      @on-clear="onClearCity()" @on-search="onSearchCity($event)">
                            <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city)">{{cityObj.city}}</div>
                            </Option>
                        </AutoComplete>
                    </div>
                </template>
            </ApolloQuery>
        </Col>
        <Col span="4">
          <Select v-model="selectedCompanyTypes" multiple filterable placeholder="Company Type">
            <Option v-for="type in companyTypes" :value="type.id" :label="type.name" :key="type.id">
              <div class="ivu-select-item-div"> {{type.name}}</div>
            </Option>
          </Select>
        </Col>
        <Col span="4">
          <Select v-model="selectedStatus" placeholder="Status" clearable>
            <Option v-for="status in ['Active', 'Inactive', 'Pending']" :value="status" :label="status" :key="status">
              <div class="ivu-select-item-div"> {{status}}</div>
            </Option>
          </Select>
        </Col>
        <Button v-if="isAdmin" @click="exportClients" :loading="exportLoading">Export CSV</Button>
        <Button @click="startAddingCompany" style="float: right;">Add Company</Button>
    </Row>

    <Spin fix size="small" v-if="skipClients"></Spin>
    <hot-table :settings="hotSettings" v-show="!skipClients" style="margin: 20px 0 10px 0"  ref="hotTableComponent">
        <hot-column v-for="(colset, index) in columns" :settings="colset" :key="index">
        </hot-column>
    </hot-table>

    <Page :total="clientsCount" :current="pageNumber" show-sizer @on-change="onChangePage" @on-page-size-change="onChangeSize"></Page>

    <register-company-drawer ref="register-company-form"></register-company-drawer>
    <edit-company-drawer ref="edit-company-form"></edit-company-drawer>

</div>
</template>

<script>
import {SEARCH_CITY2} from "../../graphql/queries/territories"
import {
  SUBSCRIBE_COMPANIES_TOTALCOUNT,
  SUBSCRIBE_EXCEL_COMPANIES
} from "../../graphql/subscription/companies"
import { HotTable, HotColumn } from '@handsontable/vue'
import Handsontable from 'handsontable'
import RegisterCompanyDrawer from "../RegisterCompanyDrawer";
import EditCompanyDrawer from "../EditCompanyDrawer";
import {GET_ALL_COMPANIES_BY_TYPE, GET_COMPANY_TYPE} from "../../graphql/queries/companies";
import moment from 'moment';
import {getAddressString} from "../ExcelFormattedOrders/RendererFunctions";
import {
  actionRenderer,
  addressRenderer,
  clientStatusRenderer, sendSMSRenderer
} from "../ExcelContractors/RendererFunctions";
import {Constants} from "../../Constants/Constant";
import {getCompanyStatusString} from "./Settings";

export default {
        name: "ExcelClients",
        components: {EditCompanyDrawer, RegisterCompanyDrawer, HotTable, HotColumn},
        props:['globalSearch'],
        apollo: {
          type: {
              query: GET_COMPANY_TYPE,
              result({data, loading}) {
                if (!loading) {
                  this.companyTypes = data.type.filter(t => t.id !== Constants.companyType.transporter);
                }
              }
            },
            $subscribe: {
              clientsCount: {
                    query: SUBSCRIBE_COMPANIES_TOTALCOUNT,
                    skip(){return this.skipClients || !this.companyTypes.length},
                    variables () {
                        return {
                            city: this.selectedCity,
                            isApproved: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapApproveStatus[this.selectedStatus]:null,
                            isRejected: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapRejectStatus[this.selectedStatus]:null,
                            companyTypes: this.selectedCompanyTypes.length?this.selectedCompanyTypes:this.companyTypes.map(t => t.id),
                            searchFilter: '%' + this.globalSearch + '%'
                        }
                    },
                    result ({ data }) {
                        this.clientsCount = data.clientsCount.aggregate.count;
                        //Actually calling below method isn't the efficient way as
                        // it make graphql calls two times [filter change & offset change]
                        this.onChangePage(1);                                             //Reset offset
                        this.$emit('onCount', this.clientsCount);
                    },
                },
                clients: {
                      query: SUBSCRIBE_EXCEL_COMPANIES,
                      skip(){return this.skipClients || !this.companyTypes.length},
                      variables () {
                          return {
                              city: this.selectedCity,
                              isApproved: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapApproveStatus[this.selectedStatus]:null,
                              isRejected: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapRejectStatus[this.selectedStatus]:null,
                              companyTypes: this.selectedCompanyTypes.length?this.selectedCompanyTypes:this.companyTypes.map(t => t.id),
                              searchFilter: '%' + this.globalSearch + '%',
                              offset: this.offset,
                              limit: this.limit
                          }
                      },
                      result ({ data }) {
                          this.clients = data.clients
                          this.prepareSheetData(data.clients)
                      },
                  }
            },
        },
        data: function () {
            return {
                query_SEARCH_CITY: SEARCH_CITY2,
                clientsCount: 0,
                clients: [],
                pageNumber: 1,
                offset: 0,
                limit: 10,
                skipClients: true,
                city: '',
                skipCity: true, //To Avoid calls at initial
                cityFilter: '%%',
                selectedCity: [],                               //[{city: "Surat"}]
                editCompanyDrawer: false,      //when add company
                columns: [
                    //table_key_intermediate
                    {
                        title: 'Type',
                        data: 'type'
                    },
                    {
                        title: 'City',
                        data: 'city'
                    },
                    {
                        title:'Company<br> Name',
                        data: 'clientName',
                        renderer: this.clientNameRenderer
                    },
                    {
                        title:'Mobile',
                        data: 'clientMobile'
                    },
                    {
                        title:'Email Id',
                        data: 'clientEmail'
                    },
                    {
                        title:'Address',
                        data: 'clientAddress',
                        renderer: addressRenderer
                    },
                    {
                        title:'GST No.',
                        data: 'clientGSTIN'
                    },
                    {
                        title:'PAN No.',
                        data: 'clientPAN'
                    },
                    {
                        title:'Total<br> Orders',
                        data: 'totalOrders',
                        type: 'numeric'
                    },
                    {
                        title:'Total<br> Billing',
                        data: 'totalBilling',
                        type: 'numeric'
                    },
                    {
                        title:'Due<br> Payment',
                        data: 'duePayment',
                        type: 'numeric'
                    },
                    {
                        title:'Status',
                        data: 'status',
                        renderer: (...args) => clientStatusRenderer(...args, this, 'clients')
                    },
                    {
                        title:'Send<br> SMS',
                        data: 'sendSms',
                        renderer: (...args) => sendSMSRenderer(...args)
                    },
                   {
                        title:'Action',
                        data: 'action',
                        renderer: (...args) => actionRenderer(...args, this, 'clients', 'onEditClient'),
                        excludeInExport: true
                    }
                ],
                hotSettings: {
                    data: null,
                    readOnly: true,                             //default all cells readOnly
                    fillHandle: false,
                    copyPaste: false,
                    licenseKey: "non-commercial-and-evaluation",
                    autoRowSize: false,
                    autoColumnSize: false,
                    colWidths: [90, 90, 110, 90, 170, 150, 125, 100, 90, 90, 100, 90, 70, 70],
                    className: "htCenter htMiddle",
                    filters: true,
                    dropdownMenu: ['filter_by_condition', 'filter_operators', 'filter_by_condition2', 'filter_by_value', 'filter_action_bar'],
                    columnSorting: { sortEmptyCells: true },
                },
                updateCompanyDrawer: false,       //when edit company
                companyTypes: [],
                selectedCompanyTypes: [],
                selectedStatus: null,
                mapApproveStatus:{Active: true, Inactive: false, Pending: false},
                mapRejectStatus:{Active: false, Inactive: true, Pending: false},
                exportLoading: false
            }
        },
        computed: {
          isAdmin: function(){
            return this.$store.state.userObj.role[0].id === Constants.adminRoleId
          }
        },
        methods: {
            onChangePage(page){
              this.offset = (page -1) * this.limit;
              this.pageNumber = page;
            },
            onChangeSize(size){
              this.limit = size;
              this.offset = (this.pageNumber -1) * this.limit;
            },
            startAddingCompany () {
                this.$refs['register-company-form'].companyType_skip = false;
                this.editCompanyDrawer = true
            },
            clientNameRenderer(instance, td, row, col, prop, value, cellProperties) {
                Handsontable.renderers.TextRenderer.apply(this, arguments);
                td.style.color = 'blue'
                td.classList.add('order-num-txt')
                let pRow = instance.toPhysicalRow(row)                               //When accessing original array
                let client = this.clients[pRow]
                let self = this
                td.onclick = function() {
                    self.$router.push({ path: '/excel-clients/'+client.id})
                }

            },
            onEditClient(row){
              this.$refs['edit-company-form'].companyType_skip = false;
              row['type'] = row.typeByType?row.typeByType.id:'-'
              this.$refs['edit-company-form'].setCompanyForm(row);
              this.updateCompanyDrawer = true
            },
            onSearchCity(event){
                    this.cityFilter = '%' + this.city + '%';
                    this.skipCity = false;
            },
            onSelectCity(city){
                    this.selectedCity = [{"city": city}]
            },
            onClearCity(){
                    this.selectedCity = []
            },
            prepareSheetData(data, forExport){
                let mainArr = []
                data.forEach(curnt => {
                    curnt.obj = {
                        type: curnt.typeByType?curnt.typeByType.name:'-',
                        city: curnt.address[0].city,
                        clientName: curnt.name,
                        clientMobile: curnt.mobile,
                        clientEmail: curnt.email,
                        clientAddress: getAddressString(curnt.address[0]),
                        clientGSTIN: curnt.gstin,
                        clientPAN: '-',
                        totalOrders: curnt.orders_aggregate.aggregate.count,
                        totalBilling: '-',
                        duePayment: '-',
                        status: forExport?getCompanyStatusString(curnt):curnt.isApproved,
                        sendSms: curnt.preference.sendSms,
                        action: '-'
                    }
                    mainArr.push(curnt.obj)
                })
                if(forExport) return mainArr
                this.hotSettings.data = mainArr
            },
            async exportClients(){
              this.exportLoading = true
              let re = /<\/?[^>]+(>|$)/g;                  //Remove html tags if any
              let str = this.columns.filter(h => !h.excludeInExport).map(h=> h.title.replace(re,"")).join(',') + '\n'
              let {data:{company}} = await this.$apollo.query({
                query: GET_ALL_COMPANIES_BY_TYPE,
                fetchPolicy: 'network-only',
                variables: {
                  city: this.selectedCity,
                  isApproved: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapApproveStatus[this.selectedStatus]:null,
                  isRejected: ['Active', 'Inactive', 'Pending'].includes(this.selectedStatus)? this.mapRejectStatus[this.selectedStatus]:null,
                  companyTypes: this.selectedCompanyTypes.length?this.selectedCompanyTypes:this.companyTypes.map(t => t.id),
                  searchFilter: '%' + this.globalSearch + '%'
                }
              })
              company = this.prepareSheetData(company, true)
              let dataKeys = this.columns.filter(h => !h.excludeInExport).map(h=> h.data)
              company.forEach(c => {
                dataKeys.forEach(k => str = str + '\"' + c[k] + '\"' + ',')               //double quotes to avoid commas within string
                str = str + '\n'
              })

              let blob = new Blob([str], {type: 'text/plain'});
              const a = window.document.createElement('a');
              a.href = window.URL.createObjectURL(blob);
              a.download = 'clients_' + moment().format('DD_MMM_YYYY_HH_mm') +'.csv';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              this.exportLoading = false
            }
        },
    mounted(){
        setTimeout(() => {
            this.skipClients = false
        }, 500)
    }
    }
</script>

<style scoped>
    /deep/  .ivu-spin-fix {
        top: 43px;
        left: 16px;
        z-index: 8;
        width: 86vw;
        height: 40vh;
    }
    /deep/ .handsontable > .ht_master{
        font-size: 14px;
    }
    /deep/ .handsontable > .ht_master > .wtHolder{
        /*width: 100% !important;*/
        width: unset !important;
        height: unset !important;
    }
    .filterInput{
        width: 80%;
    }
    .refresh-icon{
        float: right;
        margin: 9px 16px;
        font-size: 14px;
        cursor: pointer;
    }
    /deep/ .handsontable span.colHeader {
        font-size: 13px;
    }
    /deep/.handsontable td{
        vertical-align: middle !important;
        padding: 0 1px 0 1px !important;
        white-space: unset !important;
        font-size: 13px;
    }

    /deep/.handsontable th{
        background-color: #d9d9d9;
        color: #222;
        text-align: center;
        font-weight: 600;
        vertical-align: middle !important;
        white-space: nowrap !important;
        padding: 0 0px 0 0px !important;
    }
</style>
<style>
    .order-num-txt:hover {
        text-decoration: underline;
    }
    .address-txt{
        width: 145px;
        white-space: nowrap;
        overflow: hidden;
        display: inline-block;
        text-overflow: ellipsis;
        /*border: 1px solid #ddd;*/
        margin: 0px 0px 0px 5px;
    }
    .action-edit{
      font-size: 12px;
      color:grey;
      margin-right:15px;
      cursor: pointer;
    }
    .action-delete{
      font-size: 12px;
      color:red;
      cursor: pointer;
    }
    .action-delete:hover{
      color: #FF8C00;
    }
    .action-edit:hover{
      color: #c0c0c0;
    }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
